import { Injectable } from '@angular/core';

declare const turnstile: any;

@Injectable({ providedIn: 'root' })
export class TurnstileService {
  private widgetId: string | null = null;
  private isReady = false;
  private pendingResolve: ((token: string) => void) | null = null;
  private pendingReject: ((reason?: any) => void) | null = null;

  /**
   * Initialize the Turnstile widget once.
   */
  init(siteKey: string) {
    const el = document.getElementById('turnstile-widget');
    if (!el || this.widgetId) return;

    el.innerHTML = ''; // Clear container

    try {
      this.widgetId = turnstile.render('#turnstile-widget', {
        sitekey: siteKey,
        size: 'invisible',
        callback: (token: string) => {
          this.isReady = true;
          if (this.pendingResolve) this.pendingResolve(token);
          this.pendingResolve = null;
          this.pendingReject = null;
        },
        'error-callback': () => {
          if (this.pendingReject) this.pendingReject('Turnstile error.');
          this.pendingResolve = null;
          this.pendingReject = null;
        },
      });
    } catch (e) {
      console.error('Failed to render Turnstile.', e);
    }
  }

  /**
   * Execute Turnstile with dynamic action
   */
  execute(siteKey: string, action: string): Promise<string> {
    return new Promise((resolve, reject) => {
      const el = document.getElementById('turnstile-widget');
      if (!el) return reject('Turnstile container not found.');

      // Initialize if not done yet
      if (!this.widgetId) this.init(siteKey);

      this.pendingResolve = resolve;
      this.pendingReject = reject;

      try {
        // Set the action dynamically before executing
        turnstile.execute(this.widgetId, { action });
      } catch (e) {
        this.pendingResolve = null;
        this.pendingReject = null;
        reject('Failed to execute Turnstile.');
      }
    });
  }
}
